import React from 'react';

export const FormErrors = ({formErrors}) =>

  <div className="alert alert-danger" role="alert">
    {Object.keys(formErrors).map((fieldName, i) => {
      if(formErrors[fieldName].length > 0){
        return (
          <p key={i}>{formErrors[fieldName]}</p>
        )        
      } else {
        return '';
      }
    })}
  </div>